export const LeadFinder = `mutation LeadFinder($businessid: ID!, $locationid: ID!, $count: Int!, $companies: String, $names: String, $titles: String, $seniorities: String, $departments: String, $keywords: String, $industries: String, $employeesizes: String, $estimatedrevenues: String) {
  leadFinder(businessid: $businessid, locationid: $locationid, count: $count, companies: $companies, names: $names, titles: $titles, seniorities: $seniorities, departments: $departments, keywords: $keywords, industries: $industries, employeesizes: $employeesizes, estimatedrevenues: $estimatedrevenues) {
    requestid
    requestno
    leadcount
    files
    iscompleted
    createdAt
    updatedAt
  }
}`

export const BusinessLeadLimit = `query businessusagebybusinesswithtype($businessid:ID!,$plantype: [Int!]){
              businessusagebybusinesswithtype(businessid:$businessid, plantype:$plantype){  
                businessid,
                      isunlimitedleadfinder
                      leadfinderlimit
                      leadfinder
                      }
              }`

export const UpdateLeadRequest = `mutation UpdateLeadRequest($requestid: ID!, $files: String) {
  updateLeadRequest(requestid: $requestid, files: $files)
}`

export const LeadFinderList = `query LeadFinderRequest($locationid: ID!, $pagenumber: Int!, $pagesize: Int!) {
  leadFinderRequest(locationid: $locationid, pagenumber: $pagenumber, pagesize: $pagesize) {
    count
    rows {
      requestid
      requestno
      leadcount
      files
      iscompleted
      createdAt
      updatedAt
    }
  }
}`

export const LeadRequest = `query LeadFinderRequestbyid($requestid: ID!) {
  leadFinderRequestbyid(requestid: $requestid) {
    requestid
    requestno
    leadcount
    files
    iscompleted
    createdAt
    updatedAt
  }
}`